const alphanumeric = (value) => value && /[^a-zA-Z0-9]/.test(value) ? 'May only contain letters and numbers' : undefined
const nameCharacters = (value) => value && /[^-a-zA-Z0-9' ]/.test(value) ? 'May only contain letters, numbers, spaces \' and -' : undefined

export { alphanumeric, nameCharacters }